__turbopack_context__.v({
  "className": "archivo_black_e01aba6f-module__9y32tG__className",
});
